import { CircleLoader } from "@/components/shared/loaders";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

export type PropsCustomAlertDialog = {
  actionButtonFn: () => void;
  open: boolean;
  onOpenChange: Dispatch<SetStateAction<boolean>>;
  body: React.ReactNode | string;
  title: string;
  loading?: boolean;
};

const CustomAlertDialog = (props: PropsCustomAlertDialog) => {

  const { actionButtonFn, open, onOpenChange, body, title, loading } = props;

  const { t } = useTranslation(["components", "common"]);

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{ title }</AlertDialogTitle>
          <AlertDialogDescription>
            {body}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>
            { t("common:buttons.cancel") }
          </AlertDialogCancel>
          <AlertDialogAction onClick={actionButtonFn} disabled={loading} className="gap-2">
            <CircleLoader visible={loading} height={16} width={16} strokeWidth={2}/>
            { t("common:buttons.confirm") }
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default CustomAlertDialog;
